
/*
 * default side menu
 * */
import { MenuItem } from '@/types/menuItem';
import { Clinics } from '@/models/clinics';
import { Doctors } from '@/models/doctors';
import { Patients } from '@/models/patients';
import { MedicalServiceTypes } from '@/models/medicalServiceTypes';
import { EVERYONE, ADMIN_ROLES } from '@/store/user';

export const menuItems: Record<string, MenuItem> = {
    requests: {
        name: 'Заявки',
        path: 'requests',
        code: 'requests',
        isActive: true,
        class: 'address-book',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: ADMIN_ROLES,
    },
    calendar: {
        name: 'Календарь',
        path: 'calendar',
        code: 'calendar',
        isActive: true,
        class: 'calendar-alt',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: EVERYONE,
    },
    clinics: {
        name: 'Клиники',
        path: `${Clinics.moduleName}`,
        code: `${Clinics.moduleName}`,
        isActive: true,
        class: 'clinic-medical',
        hint: '',
        hintClass: '',
        iconSize: '18',
        roles: ADMIN_ROLES,
    },
    doctors: {
        name: 'Врачи',
        path: `${Doctors.moduleName}`,
        code: `${Doctors.moduleName}`,
        isActive: true,
        class: 'user-md',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: ADMIN_ROLES,
    },
    patients: {
        name: 'Пациенты',
        path: `${Patients.moduleName}`,
        code: `${Patients.moduleName}`,
        isActive: true,
        class: 'user-friends',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: EVERYONE,
    },
    directories: {
        name: 'Справочники',
        path: `${MedicalServiceTypes.moduleName}`,
        code: 'directories',
        isActive: true,
        class: 'folder-plus',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: ADMIN_ROLES,
    },
    consultations: {
        name: 'Консультации',
        path: 'consultations',
        code: 'consultations',
        isActive: true,
        class: 'stethoscope',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: EVERYONE,
    },
    payments: {
        name: 'Платежи',
        path: 'payments',
        code: 'payments',
        isActive: true,
        class: 'money-check-alt',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: ADMIN_ROLES,
    },
    stories: {
        name: 'Истории',
        path: 'stories',
        code: 'stories',
        isActive: true,
        class: 'history',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: ADMIN_ROLES,
    },
    partners: {
        name: 'Партнерские предложения',
        path: 'partners',
        code: 'partners',
        isActive: true,
        class: 'handshake',
        hint: '',
        hintClass: '',
        iconSize: '20',
        roles: ADMIN_ROLES,
    },
};
